import firebase from 'src/lib/firebase';

const getFirestore = () => {
  const firestore = firebase.firestore();

  return firestore;
};

export default getFirestore;
